import React, { useRef } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { formatCurrency, getRandomColor } from "../../utils";
import SkeletonCard from "../skeletons/SkeletonCard";
import { IconBot } from "./BotSection";

const botData = [
  {
    botName: "USAGI - BTC/USDT",
    totalProfit: 125.6,
    avgMonthlyProfit: 27.58,
    unrealizedPL: 1.04,
  },
  {
    botName: "USAGI - ETH/USDT",
    totalProfit: 249.43,
    avgMonthlyProfit: 11.24,
    unrealizedPL: 0.61,
  },
  {
    botName: "USAGI - XRP/USDT",
    totalProfit: 76.31,
    avgMonthlyProfit: 55.47,
    unrealizedPL: 2.15,
  },
  {
    botName: "USAGI - SHIB/USDT",
    totalProfit: 21.31,
    avgMonthlyProfit: 8.63,
    unrealizedPL: -0.17,
  },
  {
    botName: "USAGI - DOGE/USDT",
    totalProfit: 150.95,
    avgMonthlyProfit: 9.98,
    unrealizedPL: -0.03,
  },
];

const dashboard = [
  {
    name: "USAGI - XRP/USDT",
    avgMonthlyProfit: 55.47,
    change: "+8.2%",
    color: "#6A6A6A",
  },
  {
    name: "USAGI - BTC/USDT",
    avgMonthlyProfit: 27.58,
    change: "+7%",
    color: "#FFBA74",
  },
  {
    name: "USAGI - ETH/USDT",
    avgMonthlyProfit: 11.24,
    change: "+2.5%",
    color: "#99C5F8",
  },
  {
    name: "USAGI - DOGE/USDT",
    avgMonthlyProfit: 9.98,
    change: "-6.5%",
    color: "#FFE16B",
  },
  {
    name: "USAGI - SHIB/USDT",
    avgMonthlyProfit: 8.63,
    change: "+1.7%",
    color: "#FF9191",
  },
];

const COLORS = ["#2C2F38", "#474B58", "#A9B0BC", "#D1D4DB", "#EBEDF0"];

export const PerformanceSection = ({ dashboard, loading }) => {
  return (
    <div className="flex flex-col lg:flex-row lg:space-x-6 gap-5 mt-6 lg:gap-0">
      <div
        className="w-full lg:w-1/2 bg-white rounded-xl p-4 overflow-y-auto"
        // style={{ border: "1px solid #dde1e6" }}
      >
        <table className="w-full text-left border-collapse">
          <thead>
            <tr>
              <th className="p-3 text-base text-left">Running Bot</th>
              <th className="p-3 text-base text-center">Total Profit</th>
              <th className="p-3 text-base text-center">Avg. Monthly Profit</th>
              <th className="p-3 text-base text-center">Current Value</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              [...Array(5)].map((_, idx) => (
                <tr key={idx}>
                  <td className="p-3 text-sm text-left">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["50px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-3 text-sm text-center">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className="p-3 text-sm text-center">
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["40px"]}
                      heights={["10px"]}
                    />
                  </td>
                  <td className={`p-3 text-sm text-center`}>
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["60"]}
                      heights={["10px"]}
                    />
                  </td>
                </tr>
              ))
            ) : dashboard?.bot_profit_stats?.length ? (
              dashboard?.bot_profit_stats?.map((bot, idx) => (
                <tr key={bot.bot_id}>
                  <td className="p-3 text-sm text-left ">
                    <div className="flex items-center">
                      <IconBot
                        src={`/images/icons/icon_wallet_${bot.exchange}.svg`}
                        alt={bot.exchange}
                        className={
                          "w-full relative z-[2] !max-w-[25px] !h-[25px] mr-2 !border !border-[black]/10"
                        }
                      />{" "}
                      {bot.pair}
                    </div>
                  </td>
                  <td className="p-3 text-sm text-center">
                    {formatCurrency(bot.total_profit || 0)}
                  </td>
                  <td className="p-3 text-sm text-center">
                    {formatCurrency(bot.avg_monthly_profit || 0)}
                  </td>
                  <td
                    // className={`p-3 text-sm text-center ${
                    //   bot?.unrealized_pl.includes("+") ||
                    //   Number(bot?.unrealized_pl) > 0
                    //     ? "text-green-500"
                    //     : "text-red-500"
                    // }`}
                    className={`p-3 text-sm text-center `}
                  >
                    {/* {bot.unrealized_pl.includes("+") ? "+" : ""} */}
                    {formatCurrency(bot.current_value || 0)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className="h-[10rem]  p-3 text-sm text-center text-gray-400"
                  colSpan={4}
                >
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div
        className="w-full lg:w-1/2 bg-white rounded-xl p-4 flex flex-col"
        // style={{ border: "1px solid #dde1e6" }}
      >
        <h2 className="text-xl text-black font-semibold  mb-4 px-2">
          Best Performing Bot (based on Avg. Monthly Profit)
        </h2>

        <div className="flex flex-col md:flex-row items-center">
          {/* Pie Chart */}
          <div
            className={`relative h-[180px] w-[180px] flex-shrink-0 ${
              !dashboard?.best_pairs?.length && !loading && "hidden"
            }`}
          >
            {loading ? (
              <div className="relative w-fit">
                <div className="absolute w-[100px] h-[100px] rounded-full bg-white z-10  top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]" />
                <SkeletonCard type="avatar" avatarSize={160} />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={
                      dashboard?.best_pairs?.length ? dashboard?.best_pairs : []
                    }
                    dataKey="pie_chart"
                    nameKey="name"
                    innerRadius="60%"
                    outerRadius="100%"
                    paddingAngle={2}
                  >
                    {dashboard?.best_pairs.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={entry.color}
                        stroke="none" // Menghilangkan border antar slice
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>

          {/* Legend + Info List */}
          <div className="w-full pl-0 md:pl-6 mt-4 md:mt-0">
            <ul className="space-y-2">
              {loading ? (
                [...Array(4)].map((_, idx) => (
                  <li
                    key={idx}
                    className="flex items-center justify-between text-sm p-1 rounded-md hover:bg-gray-50"
                  >
                    {/* Legend + Name */}
                    <div className="flex items-center space-x-2">
                      <span
                        className="w-3 h-3 rounded-full"
                        style={{ backgroundColor: getRandomColor() }}
                      />
                      <span className="font-medium text-gray-700 truncate">
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["60px"]}
                          heights={["10px"]}
                        />
                      </span>
                    </div>

                    {/* Profit & Change */}
                    <div className="flex items-center space-x-3">
                      <span className="text-gray-600">
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["30px"]}
                          heights={["10px"]}
                        />
                      </span>
                      <span className={`font-medium py-1 rounded-full p-2 `}>
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["30px"]}
                          heights={["10px"]}
                        />
                      </span>
                    </div>
                  </li>
                ))
              ) : !!dashboard?.best_pairs?.length ? (
                dashboard?.best_pairs.map((bot, idx) => (
                  <li
                    key={idx}
                    className="flex items-center justify-between text-sm p-1 rounded-md hover:bg-gray-50"
                  >
                    {/* Legend + Name */}
                    <div className="flex items-center space-x-2">
                      <span
                        className="w-3 h-3 rounded-full inline-block"
                        style={{ backgroundColor: bot.color }}
                      />
                      <span className="font-medium text-gray-700 truncate flex  items-center">
                        <IconBot
                          src={`/images/icons/icon_wallet_${bot.exchange}.svg`}
                          alt={bot.exchange}
                          className={
                            "w-full relative z-[2] !max-w-[25px] !h-[25px] mr-2 !border !border-[black]/10"
                          }
                        />{" "}
                        {bot.coin_name}
                      </span>
                    </div>

                    {/* Profit & Change */}
                    <div className="flex items-center space-x-3">
                      <span className="text-gray-600">
                        {formatCurrency(bot.pnl_converted || 0)} USDT
                      </span>
                      <span
                        className={`font-medium py-1 rounded-full p-2 ${
                          bot.change.includes("-")
                            ? "text-red-500 bg-red-500/10"
                            : "text-green-500 bg-green-500/10"
                        }`}
                      >
                        {bot.change}
                      </span>
                    </div>
                  </li>
                ))
              ) : (
                <div className="text-sm w-full h-[10rem] flex justify-center items-center -ml-6 text-gray-500">
                  No data found
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
